import React, { use, useState, useEffect } from "react";
import {
  Typography,
  Box,
  Tabs,
  Tab,
  IconButton,
  Tooltip,
  Stack,
} from "@mui/material";
import { getAgentRunPrompt, getAgentRunResult } from "../../api/agentApi";

// Icons
import PromptResponse from "./PromptResponse.tsx";
import { Artifact } from "../../types.ts";
import GeneralTabPanel from "./GeneralTabPanel.jsx";
import ArtifactsTabContent from "./ArtifactsTabContent.tsx";
import CloseIcon from "@mui/icons-material/Close";

interface RunDetailsContentProps {
  run: any;
  activeTabIndex: number;
  onClose: () => void;
  onTabChange: (event: React.SyntheticEvent, newValue: number) => void;
  onDownload: (event: React.MouseEvent, artifact: Artifact) => void;
}

const AgentRunDetailsContent: React.FC<RunDetailsContentProps> = ({
  run,
  onClose,
  activeTabIndex,
  onTabChange,
  onDownload,
}) => {
  const [prompt, setPrompt] = useState<any>(undefined);
  const [result, setResult] = useState<any>(undefined);
  useEffect(() => {
    try {
      getAgentRunPrompt(run.agent_id, run.agent_version, run.run_number).then(
        (prompt: any) => setPrompt(prompt?.prompt)
      );
    } catch (err) {
      console.error("Failed to fetch prompt for agent run:", err);
    }
    try {
      getAgentRunResult(run.agent_id, run.agent_version, run.run_number).then(
        (result: any) => setResult(result?.output)
      );
    } catch (err) {
      console.error("Failed to fetch result for agent run:", err);
    }
  }, [run.agent_id]);

  const a11yProps = (index: number) => {
    return { id: `tab-${index}`, "aria-controls": `tabpanel-${index}` };
  };
  return (
    <Box
      sx={{
        flexGrow: 1,
        minHeight: 0,
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Box sx={{ px: 2,py: 1, bgcolor: "action.hover" }}>
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          // border={1}
        >
          <Stack direction="column" spacing={0.5}>
          <Typography
            variant="caption"
            display="block"
            sx={{ fontWeight: "bold" }}
          >
            Run Date: {new Date(run?.created_at).toLocaleString()}
          </Typography>
          <Typography
            variant="caption"
            display="block"
            sx={{ fontWeight: "bold" }}
          >
            Run Number: {run?.run_number}
          </Typography>
          </Stack>
          <Tooltip title="Close Drawer">
            <IconButton
              onClick={onClose}
              size="large"
            >
              <CloseIcon />
            </IconButton>
          </Tooltip>
        </Box>
      </Box>

      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs
          value={activeTabIndex}
          onChange={onTabChange}
          aria-label="run details tabs"
          variant="fullWidth"
        >
          <Tab
            sx={{ textTransform: "none" }}
            label="Agent Prompt and Response"
            {...a11yProps(0)}
          />
          <Tab
            sx={{ textTransform: "none" }}
            label={`Artifacts`}
            {...a11yProps(2)}
          />
        </Tabs>
      </Box>

      <Box
        sx={{
          flexGrow: 1,
          minHeight: 0,
          display: "flex",
          flexDirection: "column",
        }}
      >
        <GeneralTabPanel value={activeTabIndex} index={0}>
          <PromptResponse prompt={prompt} result={result} />
        </GeneralTabPanel>
        <GeneralTabPanel value={activeTabIndex} index={1}>
          <ArtifactsTabContent
            run={run}
            onDownload={onDownload}
          />
        </GeneralTabPanel>
      </Box>
    </Box>
  );
};

export default AgentRunDetailsContent;
